import { useEffect, useMemo, useState } from "react";
import { NivelPerfil } from "../../models/monitoreo/NivelPerfil";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Generico } from "../../components/Generico";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { TablaRiesgos } from "./TablaRiesgos";
import { useToken } from "../../components/useToken";
import { Button } from "primereact/button";
import { useLazyParams } from "../../hooks/useLazyParams";
import { MatrizRiesgoCandidata } from "../../models/monitoreo/MatrizRiesgoCandidata";
import { TablaDinamica } from "../../components/TablaDinamica";
import { Column } from "primereact/column";
import { Divider } from "primereact/divider";
import { InputSwitch } from "primereact/inputswitch";
import { TablaDetalleCandidata } from "./TablaDetalleCandidata";

export const ListaRiesgo = ({ toast, permss, funcionalidades, generic }) => {
    const omodel = new NivelPerfil();
    const model = omodel.model;
    const defaultValues = generic.default(model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, watch } = useForm({ defaultValues });
    const [registers, setRegisters] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams, inText, inCalendar, inNumber } = InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });
    const monitoreoSrv = new MonitoreoService();
    const [dialogMatriz, setDialogMatriz] = useState(false);
    const [matriz, setMatriz] = useState(null);
    const [dialogMonitoreo, setDialogMonitoreo] = useState(false);
    const { accionesTbl } = Generico();
    const [editarApetitos, setEditarApetitos] = useState(false);
    const { getRol } = useToken();
    const [guardando, setGuardando] = useState(false);
    const [matrizSeleccionada, setMatrizSeleccionada] = useState(null);
    const [dialogMigracion, setDialogMigracion] = useState(false);
    const [expandedRows, setExpandedRows] = useState(null);
    const MatricesCandidatasModel = useMemo(() => new MatrizRiesgoCandidata().model, []);
    const tablaEstadoMatrices = useLazyParams({ modelo: MatricesCandidatasModel, initialRows: 5 });

    const fechaInicioWatch = watch('fecha_inicio');
    const fechaFinWatch = watch('fecha_fin');

    useEffect(() => {
        // Si estamos creando una matriz nueva y ya había una matriz seleccionada
        if (getValues('id') == null && getValues('matriz_origen_id')) {
            setValue('matriz_origen_id', null);
            setMatrizSeleccionada(null);
            toast.current?.show({ severity: 'info', summary: 'Fechas modificadas', detail: 'Se deseleccionó la matriz de migración debido al cambio de fechas.' });
        }
        // eslint-disable-next-line
    }, [fechaInicioWatch, fechaFinWatch]);

    const seleccionarMatrizOrigen = (rowData) => {
        setValue('matriz_origen_id', rowData.id);
        setMatrizSeleccionada(rowData);
        toast.current.show({
            severity: 'success',
            summary: 'Matriz vinculada',
            detail: `Se migrará información de: ${rowData.nombre}`
        });
        setDialogMigracion(false);
    };

    const cuerpoTemplates = {
        accionesBody: (rowData) => (
            <div className="flex justify-content-center">
                <Button type="button" icon="pi pi-check-circle" label="Elegir para migrar" className="p-button-sm p-button-outlined"
                    onClick={() => seleccionarMatrizOrigen(rowData)} />
            </div>
        ),
    };

    const rowExpansionTemplate = (rowData) => {
        const inicio = getValues('fecha_inicio');
        const fin = getValues('fecha_fin');
        return (
            <TablaDetalleCandidata matriz={rowData} monitoreoSrv={monitoreoSrv} generic={generic} toast={toast} setError={setError}
                getRol={getRol} fechaInicio={inicio} fechaFin={fin} />
        );
    };

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [lazyParams]);

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo-perfil',
            message: '¿Está seguro de eliminar la matriz?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarRol()
        });
    }

    const eliminarRol = () => {
        monitoreoSrv.eliminar(matriz?.id, 'monitoreo/nivel-riesgo-perfil/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setMatrizSeleccionada(null);
        setDialogMatriz(true);
    }

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        monitoreoSrv.listado('monitoreo/nivel-riesgo-perfil/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
        });
    }

    const loadMatricesCandidatas = () => {
        const inicio = getValues('fecha_inicio');
        const fin = getValues('fecha_fin');
        if (!inicio || !fin) return;
        tablaEstadoMatrices.setLoading(true);
        let _lazyParams = { ...tablaEstadoMatrices.lazyParams };
        if (getRol()) { _lazyParams.rol = getRol(); }

        const payload = {
            lazyEvent: JSON.stringify(_lazyParams),
            fecha_inicio: generic.dateToString(inicio),
            fecha_fin: generic.dateToString(fin)
        };

        monitoreoSrv.consultarInfo('monitoreo/nivel-riesgo-perfil/listar-candidatas-migracion', payload).then(res => {
            tablaEstadoMatrices.setData(res.data.registros);
            tablaEstadoMatrices.setTotalRecords(res.data.total);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            tablaEstadoMatrices.setLoading(false);
        });
    };

    useEffect(() => {
        if (dialogMigracion) {
            loadMatricesCandidatas();
        }
        // eslint-disable-next-line
    }, [tablaEstadoMatrices.lazyParams, dialogMigracion]);

    const buscarMatricesOrigen = () => {
        const inicio = getValues('fecha_inicio');
        const fin = getValues('fecha_fin');

        if (!inicio || !fin) {
            toast.current.show({ severity: 'warn', summary: 'Fechas requeridas', detail: 'Debe ingresar fecha inicio y fin primero.' });
            return;
        }
        setDialogMigracion(true);
    };

    const onSubmit = (data) => {
        if (editarApetitos) {
            let hayError = false;
            ['apetito_inherente', 'tolerancia_inherente', 'apetito_residual', 'tolerancia_residual'].forEach(field => {
                if (data[field] > 5) { setError(field, { type: 'manual', message: 'El valor máximo permitido es 5' }); hayError = true; }
            });
            // Alerta Apetito > Tolerancia
            if (data.apetito_inherente > data.tolerancia_inherente) {
                setError('apetito_inherente', { type: 'manual', message: 'El apetito debe ser menor o igual a la tolerancia' }); hayError = true;
            }
            if (data.apetito_residual > data.tolerancia_residual) {
                setError('apetito_residual', { type: 'manual', message: 'El apetito debe ser menor o igual la tolerancia' }); hayError = true;
            }
            if (hayError) return;
        } else { delete data.apetito_inherente; delete data.tolerancia_inherente; delete data.apetito_residual; delete data.tolerancia_residual; }
        data.fecha_inicio = generic.dateToString(data.fecha_inicio);
        data.fecha_fin = generic.dateToString(data.fecha_fin);
        if (!data.matriz_origen_id) delete data.matriz_origen_id;
        setGuardando(true);
        if (getValues('id') == null) {
            data.tipo_rango_fecha = 'TIP_RAN_FEC_MATRIZ_FECHAS';
            monitoreoSrv.nuevo(data, 'monitoreo/nivel-riesgo-perfil/nuevo').then(res => {
                setDialogMatriz(false);
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setGuardando(false);
            });
        }
        else {
            monitoreoSrv.editar(data, 'monitoreo/nivel-riesgo-perfil/editar').then(res => {
                setDialogMatriz(false);
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            }).finally(() => {
                setGuardando(false);
            });
        }
    }

    const editar = () => {
        setMatrizSeleccionada(null);
        monitoreoSrv.consultar(matriz?.id, 'monitoreo/nivel-riesgo-perfil/consulta').then(res => {
            const _mat = res.data;
            _mat.fecha_inicio = generic.stringToDate(_mat.fecha_inicio);
            _mat.fecha_fin = generic.stringToDate(_mat.fecha_fin);
            reset(generic.renewValues(_mat, model));
            setDialogMatriz(true);
        });
    }

    const itemsMenu = () => {
        const items = [];
        // Estado BORRADOR
        if (matriz?.nemonico === 'BORRADOR') {
            if (permss?.actualizar)
                items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
            if (permss?.actualizar)
                items.push({ label: 'Ver monitoreo', icon: 'pi pi-bars', command: () => { setDialogMonitoreo(true) } });
            if (permss?.eliminar)
                items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        // Estado ENVIADO
        if (matriz?.nemonico === 'ENVIADO') {
        }
        // Estado FINALIZADO
        if (matriz?.nemonico === 'FINALIZADO') {
            if (permss?.actualizar)
                items.push({ label: 'Ver monitoreo', icon: 'pi pi-bars', command: () => { setDialogMonitoreo(true) } });
        }
        return [{ label: 'Opciones', items }];
    }

    return (
        <>
            <ConfirmDialog group="eliminar-riesgo-perfil" className="dialog-personalizado" />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {!dialogMonitoreo && <><Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, '', permss)}></Toolbar>
                    {table({ action01: accionesTbl, reg: setMatriz, items: itemsMenu() })}</>}
                {dialogMonitoreo && <TablaRiesgos matriz={matriz} permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generic} regresar={() => { setDialogMonitoreo(false); loadLazyData(); }} />}
            </Card>

            <Dialog visible={dialogMatriz} header={getValues('id') == null ? "Nueva matriz de monitoreo" : "Editar matriz de monitoreo"}
                modal className="p-fluid dialog-personalizado"
                onHide={() => { setDialogMatriz(false); setMatrizSeleccionada(null); setValue('matriz_origen_id', null); }}
                style={{ width: '850px' }}
            >
                <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-4 mt-2">

                    <div className="surface-card p-4 shadow-2 border-round">
                        <div className="text-xl font-medium text-900 mb-3 flex align-items-center">
                            <i className="pi pi-calendar-plus text-primary mr-2 text-2xl"></i>
                            Configuración Principal
                        </div>
                        <Divider className="mt-0 mb-4" />

                        <div className="formgrid grid">
                            {inCalendar('fecha_inicio', { obl: 'no', disabled: getValues('id') !== null }, 6)}
                            {inCalendar('fecha_fin', { obl: 'no', disabled: getValues('id') !== null }, 6)}
                            {inText('codigo', { icon: 'pi pi-qrcode' }, 4)}
                            {inText('nombre', { icon: 'pi pi-pencil' }, 8)}
                            {inText('detalle', { icon: 'pi pi-align-left' }, 12)}
                        </div>
                    </div>
                    {getValues('id') == null && (
                        <div className="surface-card p-4 shadow-2 border-round bg-blue-50 border-1 border-blue-200">
                            <div className="flex flex-column md:flex-row align-items-center justify-content-between gap-3">
                                <div>
                                    <span className="text-xl font-bold text-blue-900 mb-1 flex align-items-center">
                                        <i className="pi pi-database mr-2"></i> Migración de Historial (Opcional)
                                    </span>
                                    <span className="text-sm text-blue-700 block">
                                        Herede procedimientos, justificaciones y comentarios de un monitoreo previo en este mismo rango de fechas.
                                    </span>
                                </div>
                                <Button type="button" label="Buscar Matrices" icon="pi pi-search" className="p-button-primary w-auto" onClick={buscarMatricesOrigen} />
                            </div>

                            {matrizSeleccionada && (
                                <div className="mt-4 bg-white p-3 border-round border-1 border-green-300 flex align-items-center justify-content-between shadow-1 animation-duration-300 fadein">
                                    <div className="flex align-items-center">
                                        <i className="pi pi-check-circle text-green-500 text-3xl mr-3"></i>
                                        <div>
                                            <span className="block text-sm text-500 font-medium mb-1">Matriz de origen vinculada</span>
                                            <span className="block text-900 font-bold text-lg">
                                                {matrizSeleccionada.nombre} <span className="text-primary ml-1">({matrizSeleccionada.codigo})</span>
                                            </span>
                                        </div>
                                    </div>
                                    <Button type="button" icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text" tooltip="Quitar matriz" tooltipOptions={{ position: 'top' }}
                                        onClick={() => { setValue('matriz_origen_id', null); setMatrizSeleccionada(null); }} />
                                </div>
                            )}
                        </div>
                    )}

                    <div className="surface-card p-4 shadow-2 border-round">
                        <div className="flex flex-column md:flex-row align-items-center justify-content-between mb-2">
                            <div>
                                <div className="text-xl font-medium text-900">Modificar apetitos y tolerancias (Opcional)</div>
                                <div className="text-sm text-500">Configuración de niveles de apetito y tolerancia.</div>
                            </div>
                            <div className="flex align-items-center mt-3 md:mt-0 p-2 bg-gray-50 border-round">
                                <label htmlFor="editar_apetitos" className="mr-3 font-bold text-700 cursor-pointer">Modificar parámetros</label>
                                <InputSwitch inputId="editar_apetitos" checked={editarApetitos} onChange={(e) => setEditarApetitos(e.value)} />
                            </div>
                        </div>

                        {editarApetitos && (
                            <>
                                <Divider className="mb-4" />
                                <div className="formgrid grid animation-duration-300 fadeindown">
                                    {inNumber('apetito_inherente', 0, false, { icon: 'pi pi-chart-line', tooltip: 'Apetito inherente', min: 0 }, 3)}
                                    {inNumber('tolerancia_inherente', 0, false, { icon: 'pi pi-sliders-h', tooltip: 'Tolerancia inherente', min: 0 }, 3)}
                                    {inNumber('apetito_residual', 0, false, { icon: 'pi pi-chart-line', tooltip: 'Apetito residual', min: 0 }, 3)}
                                    {inNumber('tolerancia_residual', 0, false, { icon: 'pi pi-sliders-h', tooltip: 'Tolerancia residual', min: 0 }, 3)}
                                </div>
                            </>
                        )}
                    </div>

                    <div className="flex justify-content-end mt-2">
                        {generic.buttonsForms(setDialogMatriz, guardando)}
                    </div>
                </form>
            </Dialog>
            <Dialog visible={dialogMigracion} header="Seleccionar Matriz de Origen" className="dialog-personalizado" modal style={{ width: '1200px' }} onHide={() => setDialogMigracion(false)}>
                <div className="surface-0 p-3 mb-3 border-round shadow-1">
                    <p className="m-0 text-700">
                        <i className="pi pi-info-circle mr-2 text-primary"></i>
                        Haga clic en la flecha <i className="pi pi-chevron-right text-sm"></i> de la izquierda para ver los perfiles analizados.
                        Seleccione "Elegir para migrar" en la matriz deseada.
                    </p>
                </div>
                <TablaDinamica modelo={MatricesCandidatasModel} estadoTabla={tablaEstadoMatrices} datos={tablaEstadoMatrices.data}
                    totalRegistros={tablaEstadoMatrices.totalRecords} dataKey="id" cuerpoTemplates={cuerpoTemplates}
                    expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)} rowExpansionTemplate={rowExpansionTemplate}
                    rowClassName={(rowData) => ({ 'bg-blue-50': expandedRows && expandedRows[rowData.id] })}
                >
                    <Column expander style={{ width: '4rem', backgroundColor: '#f8fafc', borderRight: '1px solid #e2e8f0' }} frozen alignFrozen="left" />
                </TablaDinamica>
            </Dialog>
        </>
    )
}